<div class="aems-card m-b-12">
  <p class="mds-content"><strong>Comments</strong></p>
  <hr class="m-b-12" />
  <div class="pure-g">
    <div class="pure-u-md-24-24 p-b-16">
      @if (partsManagementComments.remarks) {
        <p class="mds-text--body-normal">{{ partsManagementComments.remarks }}</p>
      } @else {
        <p class="mds-text--body-normal mds-neutral--weak__text-color">No comments added</p>
      }
    </div>
  </div>
</div>
